export default __webpack_public_path__ + "static/media/9.65fe6266.png";